<template>
    <div class="EmptyStateChart">
			<div class="border">
				<div class="content">
					<h5>
						{{title}}
					</h5>
					<p class="caption">
						{{caption}}
					</p>
				</div>
			</div>
    </div>
</template>

<script>
export default {
		name: 'EmptyStateChart',
		props: {
			title: {
				type: String,
				default: "Este gráfico no está disponible actualmente"
			},
			caption: {
				type: String,
				default: "Preferimos no presentar este gráfico mientras no contemos con suficientes datos para mostrar información de valor. Tan pronto podamos, lo mostraremos"
			}
		}
}
</script>

<style lang="sass">
.EmptyStateChart
	height: 100%
	width: 100%
	display: flex
	justify-content: center
	align-items: center
	min-height: 178px
	.border
		border: 2px dashed $border-light
		padding: 16px
		align-self: center
		justify-self: center
		border-radius: 4px
		margin: $sm
		@media (max-width: $phone)
			margin-top: $md
		.content
			opacity: 0.5
			h5
				font-family: $title-font
				text-align: center
				margin-bottom: $xs
			.caption
				font-family: $body-font
				text-align: center
				@include tablet-landscape
					font-size: 12px
</style>